import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Resume from '../Resume/Resume';
import './Contact.css';

const Contact = () => {
  const { t, i18n } = useTranslation();

  return (
    <section id="contact" className="contact">
      <div className="contact-content">
        <h2 className="section-title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('contact.title')) }}/>
        <div className="contact-info-container">
          <div className="contact-box">
            <div className="profile-item">
              <img 
                src="/mypic.png" 
                alt={t('accessibility.profileImage')} 
                className="profile-pic"
              />
              <h3 className="profile-name">{t('contact.name')}</h3>
              <div className="profile-links">
                <a 
                  href="https://www.linkedin.com/in/amrutham-suresh-kumar-43813b111/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="profile-icon"
                  aria-label={t('accessibility.linkedinProfile')}
                >
                  <i className="fab fa-linkedin"></i>
                </a>
                <a 
                  href="https://github.com/suresh2291" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="profile-icon"
                  aria-label={t('accessibility.githubProfile')}
                >
                  <i className="fab fa-github"></i>
                </a>
                <a
                  href="/amruthamsuresh.pdf"
                  download
                  className="profile-icon download-resume"
                  aria-label={i18n.language === 'ja' ? '履歴書をダウンロード' : 'Download Resume'}
                >
                  <i className="fas fa-file-download"></i>
                </a>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <span>amruthamsuresh2291@gmail.com</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <span>+91 9949458321</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>Hyderabad, India</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
